import React, { useRef, createRef, useEffect, useState } from "react"
import { deleteDfbAccount, getDfbAccount } from "../../services/dfbNet"
import ServiceError from "../../services/ServiceError"
import { useCandidatureManagementTeaserUrl } from "../../hooks/headerLinks/candidatureManagementTeaser"
import { onUserDetails } from "../../hooks/onUserDetails"
import DfbParagraph from "../ui-kit/dfb_paragraph"
import DfbSpinner from "../ui-kit/dfb_spinner"
import CDfbnetConnection from "../elements/c_dfbnet_connection"
import CModal from "../elements/c_modal"
import MUserPanel from "../blocks/m_user_panel"
import MUserPanelContent from "../blocks/m_user_panel_content"
import content from "../../content"

const MDfbNetLink = ({ headline }) => {
  const spinnerRef = useRef()
  const [errorMessage, setErrorMessage] = useState(null)
  const [dfbNetUser, setDfbNetUser] = useState(undefined)
  const [userEmail, setUserEmail] = useState("\xa0") // nbsp to reserve space

  const modalRef = createRef()
  const connectLink = useCandidatureManagementTeaserUrl()

  const init = async () => {
    try {
      onUserDetails(user => {
        if (user.email) {
          setUserEmail(user.email)
        }
      })
      const account = await getDfbAccount()
      if (account && account.validDfbNetAccountLink) {
        setDfbNetUser(account.preferredUserName || "")
      } else {
        setDfbNetUser(null)
      }
    } catch (e) {
      handleApiError(e)
    }
  }

  const handleApiError = err => {
    if (err.statusCode === ServiceError.STATUS_UNAUTHORIZED) {
      setErrorMessage(content.userPanels.dfbNetLink.error.unauthorized)
    } else {
      setErrorMessage(content.global.error.apiError)
    }
  }

  const openConfirmLayer = () => {
    modalRef.current.dfbModal.open()
  }

  const removeConnection = async () => {
    setDfbNetUser(undefined)
    modalRef.current.dfbModal.close()
    try {
      await deleteDfbAccount()
      setDfbNetUser(null)
    } catch (e) {
      handleApiError(e)
    }
  }

  useEffect(() => {
    if (dfbNetUser === undefined && !errorMessage) {
      spinnerRef.current.loop()
    } else {
      spinnerRef.current.stop()
    }
  }, [dfbNetUser, errorMessage])

  useEffect(() => {
    init()
  }, [])

  return (
    <>
      <MUserPanel headline={headline} errorMessage={errorMessage}>
        {dfbNetUser != null && (
          <MUserPanelContent
            headline={content.userPanels.dfbNetLink.connected.headline}
            status="success"
            richtext={content.userPanels.dfbNetLink.connected.richtext}
            buttonLabel={content.userPanels.dfbNetLink.connected.button}
            onButtonClick={openConfirmLayer}
          >
            <CDfbnetConnection email={userEmail} dfbnetId={dfbNetUser} />
          </MUserPanelContent>
        )}
        {dfbNetUser === null && (
          <MUserPanelContent
            headline={content.userPanels.dfbNetLink.disconnected.headline}
            status="error"
            richtext={content.userPanels.dfbNetLink.disconnected.richtext}
            buttonLabel={content.userPanels.dfbNetLink.disconnected.button}
            buttonLink={connectLink}
          >
            <CDfbnetConnection
              email={userEmail}
              dfbnetId={content.userPanels.dfbNetLink.disconnected.dfbnetId}
            />
          </MUserPanelContent>
        )}
        <DfbSpinner type="continuous" autoLoop={true} ref={spinnerRef} />
      </MUserPanel>
      <CModal
        ref={modalRef}
        id="dfbConnectionRemoveModal"
        isActive={true}
        headline={content.userPanels.dfbNetLink.confirm.headline}
        cancelButton={content.userPanels.dfbNetLink.confirm.cancelButton}
        actionButton={content.userPanels.dfbNetLink.confirm.actionButton}
        onAction={removeConnection}
      >
        <DfbParagraph text={content.userPanels.dfbNetLink.confirm.description} />
      </CModal>
    </>
  )
}

export default MDfbNetLink
